<template>

    <div>
        <section class="section section-shaped my-0 overflow-hidden">
            <div class="shape shape-style-3 bg-gradient-default">
                <span></span>
                <span></span>
                <span></span>
                <span></span>
            </div>
            <div class="container pt-lg ">

                <div class="row text-center justify-content-center">
                    <div class="col-lg-10">
                        <h2 class="display-3 text-white">Off The Couch is Now Open!</h2>
                    </div>
                </div>
            </div>
        </section>
        <section class="section">
            <div class="container">
                <div class="row justify-content-center mt--100">
                    <div class="col-lg-12">
                        <card gradient="white" shadow body-classes="p-lg-5">
                            <base-alert type="success">
                                <div class="row">
                                    <div class="col-1">
                                        <i class="fa fa-info-circle fa-3x"></i>
                                    </div>
                                    <div class="col-11 col-lg-11">
                                        <span><strong>{{post.text1}}</strong></span>
                                    </div>
                                </div>
                            </base-alert>
                            <h5>{{post.text2}}</h5>
                            <p>{{post.text3}}</p>
                            <div class="row justify-content-center">
                                <div class="col-lg-2">
                                    <img v-lazy="'img/brand/blog/otc-reopening/distance.png'" class="img-fluid rounded"
                                         style="height: 100px;">
                                </div>
                                <div class="col-lg-6">
                                    <h6>{{post.measures.m1.title}}</h6>
                                    <p>{{post.measures.m1.description}}</p>
                                </div>
                            </div>
                            <div class="row mt-3 justify-content-center">
                                <div class="col-lg-2">
                                    <img v-lazy="'img/brand/blog/otc-reopening/consent.png'" class="img-fluid rounded"
                                         style="height: 100px;">
                                </div>
                                <div class="col-lg-6">
                                    <h6>{{post.measures.m2.title}}</h6>
                                    <p>{{post.measures.m2.description}}
                                        <a href="https://offthecouch.io/checkin/otc"
                                           v-on:click="tracker('Waiver', 'Redirected to waiver', 'Link from reopening blog')">
                                          https://offthecouch.io/checkin/otc</a>
                                    </p>
                                </div>
                            </div>
                            <div class="row mt-3 justify-content-center">
                                <div class="col-lg-2">
                                    <img v-lazy="'img/brand/blog/otc-reopening/hand-wash.png'" class="img-fluid rounded"
                                         style="height: 100px;">
                                </div>
                                <div class="col-lg-6">
                                    <h6>{{post.measures.m3.title}}</h6>
                                    <p>{{post.measures.m3.description}}</p>
                                </div>
                            </div>
                            <div class="row mt-3 justify-content-center">
                                <div class="col-lg-2">
                                    <img v-lazy="'img/brand/blog/otc-reopening/spray.png'" class="img-fluid rounded"
                                         style="height: 100px;">
                                </div>
                                <div class="col-lg-6">
                                    <h6>{{post.measures.m4.title}}</h6>
                                    <p>{{post.measures.m4.description}}</p>
                                </div>
                            </div>
                            <div class="row justify-content-center">
                                <div class="col-lg-2">
                                    <img v-lazy="'img/brand/blog/otc-reopening/face-mask.png'" class="img-fluid rounded"
                                         style="height: 100px;">
                                </div>
                                <div class="col-lg-6">
                                    <h6>{{post.measures.m5.title}}</h6>
                                    <p>{{post.measures.m5.description}}</p>
                                </div>
                            </div>
                            <h5>{{post.text4}}</h5>
                            <p>{{post.text5}}</p>
                            <div class="row mb-3 justify-content-center">
                                <div class="col-12">
                                    <img v-lazy="'img/brand/pandorum/pan.jpg'" class="img-fluid rounded" style="height: 500px">
                                </div>

                            </div>
                            <base-button tag="a"
                                         href="/pandorum"
                                         class="mb-3"
                                         type="default"
                                         icon="ni ni-world">
                                Learn More About Pandorum
                            </base-button>
                            <base-button tag="a"
                                         v-on:click="tracker('Booking', 'Redirected to book', 'Pandorum - reopening blog post')"
                                         href="https://offthecouch.io/book/otc"
                                         class="mb-3"
                                         type="primary">
                                Book Now
                            </base-button>


                            <div class="row mt-3 ml-1">
                                <small>Tags:
                                    <badge v-for="tag in post.tags" class="mr-1" :key="tag" pill type="primary">{{tag}}</badge>
                                </small>
                            </div>
                            <hr>
                            <div class="row">
                                <div class="ml-3">
                                    <img v-lazy="'img/brand/people/nick.jpg'" alt="Circle image"
                                         class="img-fluid rounded-circle shadow" style="width: 70px;">
                                </div>
                                <div class="ml-2">
                                    <h6 class="font-weight-800">{{post.author}}</h6>
                                    <p>Founder of OTC and Escape Room fanatic</p>

                                </div>
                            </div>


                        </card>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    export default {
        name: "OtcReopening",
        data () {
            return {
                post: {
                    text1: "Off The Couch is happy to announce that we have re-opened for business! Come and join us in an adventure in a private and safe environment.",
                    text2: "Special safety measures",
                    text3: "Our top priority is to keep both our employees and our customers safe. As part of that, we are strictly adhering to the following safety measures:",
                    measures: {
                        m1: {
                            title: "Private Experiences and Reduced Capacity",
                            description: "We are also capping the number of experiences available to 2 per time window.  This ensures that multiple groups remain completely separated. "
                        },
                        m2: {
                            title: "Online Waivers",
                            description: "Waivers are available via the website or directly at"
                        },
                        m3: {
                            title: "Hand Washing, Sanitizer, and Gloves!",
                            description: "All players are strongly encouraged to wash their hands before and after each experience. Hand sanitizer and gloves will also be offered to all players."
                        },
                        m4: {
                            title: "More Cleaning!",
                            description: "Employees will have an additional 30 minutes between experiences to reset and thoroughly clean all handled items and surfaces with medical-grade disinfectants."
                        },
                        m5: {
                            title: "Required Face Masks",
                            description: "Employees will be required to wear face masks at all times. Customers will be required to wear face masks when in common areas."
                        },
                    },
                    text4: "New experiences now open to public",
                    text5: "We would also like to announce the release of a brand new experience, Pandorum. The world of Pandorum is a six hour long adventure, broken into four chapters.",
                    tags: ['covid-19', 'announcement'],
                    datePosted: "June 20, 2020",
                    author: "Nick",
                    category: "announcements"
                }
            }
        },
        methods: {
            tracker(category, action, label) {
                this.$ga.event(category, action, label)
            }
        }
    }
</script>

<style scoped>

</style>
